//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import QfPaddingMarginSizeStep from "./qf-padding-margin-size-step.vue";

export default {
    name: "QfPaddingMarginSize",
    components: { QfPaddingMarginSizeStep },
    data() {
        return {
            width: {
                value: null,
                suffix: null,
                readonly: false,
                showPopOver: false,
                actions: [
                    {
                        icon: "mdi-arrow-expand-horizontal",
                        handler: () => {
                            this.width.showPopOver = true;
                        }
                    }
                ]
            },
            height: {
                value: null,
                suffix: null,
                readonly: false,
                showPopOver: false,
                actions: [
                    { icon: "mdi-arrow-expand-vertical", handler: () => { this.height.showPopOver = true; } }
                ]
            },
            optionsWidthHeight: ["%", "auto", "px"]
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent"]),
        padding() {
            return this.activeComponent && this.properties[this.activeComponent] ? this.properties[this.activeComponent].__generics.padding : [0, 0, 0, 0];
        },
        margin() {
            return this.activeComponent && this.properties[this.activeComponent] ? this.properties[this.activeComponent].__generics.margin : [0, 0, 0, 0];
        }
    },
    watch: {
        // activeComponent: {
        //     handler(val) {
        //         this.updateValues(val);
        //     },
        //     immediate: true
        // }
    },
    methods: {
        setSelection(sel) {
            const reference = this.width.showPopOver ? this.width : this.height;
            if (sel === "auto") {
                reference.value = "auto";
                reference.suffix = null;
                reference.readonly = true;
            } else {
                reference.readonly = false;
                reference.suffix = sel;
                if (reference.value === "auto") {
                    reference.value = null;
                }
            }
        }
    }
};
